module.exports = __webpack_public_path__ + "img/guyoung_login.07b834a0.png";